import { render, staticRenderFns } from "./barraMensaje.vue?vue&type=template&id=23fb06f5"
import script from "./barraMensaje.vue?vue&type=script&lang=js"
export * from "./barraMensaje.vue?vue&type=script&lang=js"
import style0 from "./barraMensaje.vue?vue&type=style&index=0&id=23fb06f5&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports